export default __webpack_public_path__ + "static/media/tick-blue.42437a48.svg";